export default "__VITE_ASSET__TOdNV08G__"